import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  const row = Array.isArray(items) ? [...items, ...items] : [];
  return (
    <div data-testid="marquee-strip" className="bg-[#0B2E4A] py-5 overflow-hidden border-y border-white/10">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display font-medium uppercase tracking-[0.22em] text-sm sm:text-base text-[#F1E7D6]/80 px-6 flex items-center gap-6"
              >
                {item}
                <span className="text-[#D9A854]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
